import { useI18n } from "#hooks/use-i18n"

export function FormDivider({ text }: { text?: string }) {
  const { t } = useI18n()
  const defaultText = text || t("components.formDivider.orContinueWith")
  return (
    <div className="after:border-border relative text-center text-sm after:absolute after:inset-0 after:top-1/2 after:z-0 after:flex after:items-center after:border-t">
      <span className="bg-card text-muted-foreground relative z-10 px-2">{defaultText}</span>
    </div>
  )
}
